import type { Core } from 'chessboard/core/config/types';
import { StateMachine } from 'chessboard/core/state/config/types';

/**
 * Create the isDragging method
 * @param context the core context
 */
export function createIsDragging(context: Core.Context) {
  /**
   * Determine whether the user is dragging a piece
   */
  return function isDragging(): boolean {
    return context.state.get().machineState === StateMachine.States.PieceDragging;
  };
}
